module.exports = __webpack_public_path__ + "static/YoannDemeersseman-6f1d152a816919f2b736125a4749e9d5.jpg";